// components/BackButton.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Container } from 'react-bootstrap'; // or normal button
import { FaAngleLeft } from 'react-icons/fa6';

const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Hide button on specific pages (optional)
  const hideOnPaths = ['/']; // e.g. homepage
  if (hideOnPaths.includes(location.pathname)) return null;

  return (
    <Container>
        <Button 
        variant="outline-danger" 
        onClick={() => navigate(-1)} 
        style={{ top: 20,zIndex: 1000 }}
        >
        <FaAngleLeft/> Back
        </Button>
    </Container>
  );
};

export default BackButton;
